<div [class.flex]="displayFlag">
  @if (languageFlagUrl && displayFlag) {
    <app-header-language-flag-atom
      [languageFlagUrl]="languageFlagUrl"
    ></app-header-language-flag-atom>
  }
  @if (locales$ | async; as locales) {
    @if (locales.length > 1) {
      <select
        [(ngModel)]="selectLanguage"
        (change)="onChangeLanguage()"
        class="form-select cursor-pointer pl-4 py-2.5 block w-full bg-neutral-100 rounded-full font-base text-base font-normal"
      >
        @for (locale of locales; track locale) {
          <option [ngValue]="locale.locale">
            {{ locale.name | firstLetterUppercase }}
          </option>
        }
      </select>
    }
  }
</div>
